<div oui-dialog-title>
  {{ title ?? 'Confirmation' }}
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content>
  <div class="flex-vertical flex-start gap-16">
    <div style="white-space: pre-line" class="body-1 color-on-surface-emphasis">
      {{ message ?? 'Voulez-vous confimer cette action ?' }}
    </div>
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button type="text" (click)="cancel()">
    {{ cancelButtonLabel ?? 'Annuler' }}
  </oui-button>
  @if (!hideValidateButton) {
    <oui-button type="contained" (click)="validate()">
      {{ validateButtonLabel ?? 'Confirmer' }}
    </oui-button>
  }
</oui-dialog-actions>
